import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Configure, InstantSearch } from "react-instantsearch-dom";
import SearchHits from "./search-hits";
import RefinementListMenuSelect from "../search/refinement-list-menuselect";
import RefinementListChips from "../search/refinement-list-chips";

import { searchStateToUrl, urlToSearchState } from "../search/utils.js";
import typesenseClient from "../search/search-client";
import { CustomWindow } from "../../custom.window";
import { contentTypes } from "../../helpers/content-types";

import { SearchState } from "../search/types";

declare let window: CustomWindow;

const indexName: string = typeof window.__indexName === "string" ? window.__indexName : "content_prod";

const ToolsEducation = (): JSX.Element | null => {
  const history = useHistory();
  const location = useLocation();

  const [currentSearchState, setCurrentSearchState] = React.useState<SearchState>(urlToSearchState(location));
  const [initialLoad, setInitialLoad] = React.useState<boolean>(true);

  const searchClient = typesenseClient({
    sort_by: "title_sort:asc"
  });

  // Sync state when location changes
  React.useEffect(() => {
    setCurrentSearchState(urlToSearchState(location));
    
    /* Scroll to anchorlink, since element not in dom */
    setTimeout(() => {
      if(location.hash) {
        const hash = location.hash.split('#')[1];
        const element = document.getElementById(hash);
        if(element) {
          element.scrollIntoView();
        }
      }
    }, 500);
  }, [location]);

  /**
   * Event handlers
   * ===========================================================
   */
  const onSearchStateChange = (updatedSearchState: any) => {
    let state = { ...updatedSearchState, page: updatedSearchState.page, _page: updatedSearchState.page };
    // On initial load, use page from location
    if (initialLoad) {
      state = { ...updatedSearchState, page: currentSearchState.page, query: currentSearchState.query };
      setInitialLoad(false);
    }
    setCurrentSearchState(state);
    history.push(searchStateToUrl(location.pathname, state));
  };

  const hasRefinements = () => {
    if (!currentSearchState?.refinementList) {
      return false;
    }

    /*if (currentSearchState.refinementList?.categories && currentSearchState.refinementList.categories.length) {
      return true;
    } else*/ if (currentSearchState.refinementList?.tags && currentSearchState.refinementList.tags.length) {
      return true;
    }
    return false;
  };

  // Sort menu items in alphabetical order
  const sortItemsDesc = (items: any) => {
    return items
      .map((item: { label: string }) => {
        // Add prefix to content types
        const label = contentTypes.articles.types.indexOf(item.label) >= 0 ? `${contentTypes.articles.prefixName}: ${item.label}` : item.label;
        item.label = label;
        return item;
      })
      .sort((itemA: { label: string }, itemB: { label: string }) => itemA.label.localeCompare(itemB.label, "sv", { sensitivity: "base" }));
  };

  return (
    <InstantSearch indexName={indexName} searchClient={searchClient} searchState={currentSearchState} onSearchStateChange={onSearchStateChange}>
      <Configure filters="types:=[`Digitala verktyg`, `Utbildningar`, `Forskning på 5`]" hitsPerPage={100} analytics={false} enablePersonalization={false}/>
      
        <div className="sa-tools-search-box">
          <h2>Hitta bland vårt utbud</h2>
          <ul>
            <li><a href="#digitalaVerktygInternal">Digitala verktyg</a> hjälper er att komma igång eller komma vidare med arbetsmiljöarbetet.</li>
            <li><a href="#utbildningar">Utbildningarna</a> går ni igenom på arbetsplatsen, för att lära nytt eller fräscha upp kunskaperna.</li>
            <li><a href="#forskningPa5">Forskning på 5</a> är dialogstartare som passar perfekt på till exempel en arbetsplatsträff.</li>
            <li><a href="#digitalaVerktygExternal">Våra vänners verktyg</a> är stöd som kompletterar våra egna verktyg.</li>
          </ul>
          
          <p className="body-1 bold">Vad letar du efter?</p>
          <div className="sa-tools-menu-selects">
            {/*<RefinementListMenuSelect transformItems={sortItemsDesc} className="sa-tools-menu-selector" attribute="categories" operator="or" heading="Huvudområde" size="small" />*/}
            <RefinementListMenuSelect transformItems={sortItemsDesc} className="sa-tools-menu-selector" attribute="tags" operator="or" heading="Ämne" limit={100} size="small" />
          </div>
        
          {hasRefinements() && (
            <div className="sa-tools-refinement-box">
              <p className="body-1 bold">Valda filter</p>
              {/*<RefinementListChips transformItems={sortItemsDesc} className="sa-tools-refinement-chips" limit={1000} attribute="categories" />*/}
              <RefinementListChips transformItems={sortItemsDesc} className="sa-tools-refinement-chips" limit={1000} attribute="tags" />
            </div>
          )}
        </div>

      <SearchHits />
    </InstantSearch>
  );
};

export default ToolsEducation;
